import React from 'react';
import styles from './index.module.scss';
import { formatContentHTML } from '../../../../../utils/formatBoldText';
import { formatCardFilterText } from '../../../../../utils/formatFilterText';
import AuthorAvatars from '../../../other_components/author_avatars';

const normalizeText = (value) => {
  const text = String(value ?? '').trim();
  if (!text || text.toLowerCase() === 'none') return '';
  return text;
};

const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength).trim()}...`;
};

const getImageFileName = (content) => {
  const rawName = normalizeText(content?.img_name);
  if (!rawName) return '';
  if (rawName.includes('\\')) return rawName.substring(rawName.lastIndexOf('\\') + 1);
  if (rawName.includes('/')) return rawName.split('/').pop();
  return rawName;
};

const ArticleFreeBlock = ({
  blockData,
  path_to_folder,
  onDetailsClick,
  authorAvatars = [],
  filterA,
  filterB,
  imgs_for_filters,
}) => {
  const filterAImage = React.useMemo(() => {
    if (!filterA || !imgs_for_filters || imgs_for_filters.length === 0) return null;
    const filterAStr = Array.isArray(filterA) ? filterA.join(', ') : String(filterA);
    const matched = imgs_for_filters.find((item) => item.word === filterAStr);
    return matched ? matched.img : null;
  }, [filterA, imgs_for_filters]);
  if (!blockData?.block_content || !Array.isArray(blockData.block_content)) {
    return null;
  }

  const blockContent = blockData.block_content;

  const imageContent = blockContent.find(
    (item) => (item?.cotent_type === 'img' || item?.content_type === 'img') && getImageFileName(item),
  );

  const titleContent = blockContent.find(
    (item) =>
      (item?.cotent_type === 'text' || item?.content_type === 'text') &&
      (item?.cotent_tag === 'title' || item?.content_tag === 'title') &&
      normalizeText(item?.content_text),
  );

  const descriptionContent = blockContent.find(
    (item) =>
      (item?.cotent_type === 'long_text' || item?.content_type === 'long_text') &&
      (item?.cotent_tag === 'description' || item?.content_tag === 'description') &&
      normalizeText(item?.content_text),
  );

  const imageDescriptionTexts = blockContent
    .filter((item) => item?.cotent_type === 'img' || item?.content_type === 'img')
    .map((item) => normalizeText(item?.content_text))
    .filter(Boolean);

  const imageSrc =
    imageContent && path_to_folder ? `${path_to_folder}${getImageFileName(imageContent)}` : '';

  const hasBody = titleContent || descriptionContent || imageDescriptionTexts.length > 0;

  const hasDescription =
    Boolean(descriptionContent) ||
    imageDescriptionTexts.length > 0;

  return (
    <article className={styles.articleFreeBlock}>
      {imageSrc && (
        <div className={styles.coverWrap}>
          <img src={imageSrc} alt='' className={styles.coverImage} loading='lazy' draggable={false} />
        </div>
      )}

      <div className={styles.body}>
        {titleContent && (
          <div className={styles.titleSection}>
            <div className={styles.titleAndFiltersContainer}>
              <div className={styles.titleWrap}>
                <h3
                  className={styles.cardTitle}
                  dangerouslySetInnerHTML={{
                    __html: formatContentHTML(normalizeText(titleContent.content_text)),
                  }}
                />
              </div>
              {filterA && (
                <div className={styles.filtersContainer}>
                  <div className={styles.filterBadge}>
                    {filterAImage ? (
                      <img src={filterAImage} alt='filter' className={styles.filterImage} />
                    ) : (
                      <span className={styles.filterValue}>
                        {Array.isArray(filterA) ? filterA.join(', ') : String(filterA)}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {titleContent && hasDescription && <div className={styles.titleRule} aria-hidden='true' />}

        {descriptionContent && (
          <div className={styles.descriptionWrap}>
            <p
              className={styles.cardDescription}
              dangerouslySetInnerHTML={{
                __html: formatContentHTML(
                  truncateText(normalizeText(descriptionContent.content_text), 420),
                ),
              }}
            />
          </div>
        )}

        {!descriptionContent &&
          imageDescriptionTexts.map((text, index) => (
            <div key={`desc-${index}`} className={styles.descriptionWrap}>
              <p
                className={styles.cardDescription}
                dangerouslySetInnerHTML={{ __html: formatContentHTML(text) }}
              />
            </div>
          ))}

        {!hasBody && !imageSrc && (
          <p className={styles.emptyMessage}>Контент статьи пока не заполнен</p>
        )}

        <div className={styles.cardFooter}>
          <AuthorAvatars authors={authorAvatars} variant='light' placement='footer' />
        </div>

        <div className={styles.bottomActionRow}>
          {filterB && filterB !== 'все' && (
            <span className={styles.filterBText}>{formatCardFilterText(filterB)}</span>
          )}
          <div className={styles.bottomUnderline} aria-hidden='true' />
          {onDetailsClick && (
            <button type='button' className={styles.detailsButton} onClick={onDetailsClick}>
              Подробнее
            </button>
          )}
        </div>
      </div>

      <div className={styles.bottomRightFill} aria-hidden='true' />
    </article>
  );
};

export default ArticleFreeBlock;
